import Base64 from "./preview.js";
export default {
  methods: {
    hanldeDownPreView(url) {
      let downUrl = `${process.env.VUE_APP_BASE_API}api/business/file/download?source=${url}&fullfilename=${url}`;
      let encodeURI = encodeURIComponent(Base64.encode(downUrl));
      let base = "http://filecs.sxjsrd.rdtest.cn/onlinePreview?";
      window.open(`${base}url=${encodeURI}`);
    },
  },
};
